import React, { useEffect } from "react";
import * as Yup from "yup";
import FormField from "Components/Forms/FormComponent/FormFiled";
import InputFiled from "Components/Forms/InputForm/InputField";
import TextAreaInput from "Components/Forms/TextAreaForm/TextArea";
import FileUpload from "Pages/WorkInformation/FileUpload/FileUpload";
import { useState } from "react";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";
import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckDouble,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import axiosInstance from "../../axios";
import CustomReactSelect from "Components/Forms/ReactSelect/ReactSelect";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import { useNavigate } from "react-router-dom";
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from "firebase/storage";

import { doc, getDoc, collection, addDoc, updateDoc, arrayRemove } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { FieldArray, Formik, Form } from "formik";
import SliderUploader from "Pages/WorkInformation/FileUpload/SliderUploader";

const Contact = () => {
  const { t, i18n } = useTranslation(); // Initialize the useTranslation hook
  const [documentData, setDocumentData] = useState(null);
  const [itemsOrderr, setItemsOrder] = useState([]); // Translated options

  // FORM SUBMIT
  const validationSchema = Yup.object().shape({
    email: Yup.string().required(t("required")),
    number: Yup.string().required(t("required")),
    facebook: Yup.string().required(t("required")),
    instagram: Yup.string().required(t("required")),
    linkedin: Yup.string().required(t("required")),
    twitter: Yup.string().required(t("required")),


  });

  const [initialValues, setInitialValues] = useState({

    email: "",
    number: "",
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: "",

  });
  const [Fetchloading, setFetchloading] = useState(false);

  const handleDelete = async (index) => {
    const fileToDelete = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);

    setSelectedFiles(updatedFiles);

    try {
      // Extract the file path and delete from Firebase Storage if it's a firebase URL
      if (fileToDelete.downloadURL && fileToDelete.downloadURL.includes("/o/")) {
        const filePath = decodeURIComponent(fileToDelete.downloadURL.split("/o/")[1].split("?")[0]);
        const storageRef = ref(storage, filePath);
        await deleteObject(storageRef);
      }

      // Remove download URL from Firestore
      const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
      await updateDoc(docRef, {
        urls: arrayRemove(fileToDelete.downloadURL),
      });

      toast.success(t("FileDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(t("FileDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };


  const [City, setCity] = useState();
  const [loading, setloading] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilesError, setSelectedFilesError] = useState(false);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const [selectedFilesError2, setSelectedFilesError2] = useState(false);
  const [SelectedCategory, setSelectedCategory] = useState();
  const [SelectedCity, setSelectedCity] = useState();
  const [SelectedCategoryError, setSelectedCategoryError] = useState();
  const [SelectedCityError, setSelectedCityError] = useState();
  const [items, setItems] = useState(["contractor", "advisor", "provider"]); // Translated options
  const type = useSelector((state) => state.auth.type);

  // OEPN AND CLOSE MODAL
  const [showModal, setShowModalSuccess] = useState(false);
  // CLOSE MODAL
  const router = useNavigate();
  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };
  // OPEN MODAL
  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  // ADD CLASS ACTIVE
  const [activeItem, setActiveItem] = useState(0);

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleSubmit = async (values) => {
    console.log(values);
    setloading(true);
    try {
      const docRef = doc(db, "contact", "text");
      await updateDoc(docRef,
        values
      );
      // await addDoc(collection(db, "OurClinc"), {
      //   items:['asda','dasdas','asdas']
      // });

      toast.success("Our Clinc section updated successfully");

    } catch (err) {

    }
    setloading(false)
  };
  useEffect(() => {
    const fetchDocument = async () => {
      try {
        const docRef = doc(db, "contact", "text");
        setFetchloading(true);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());
          setDocumentData(docSnap.data());
          const tempObj = {
            email: docSnap.data().email,
            number: docSnap.data().number,
            facebook: docSnap.data().facebook,
            instagram: docSnap.data().instagram,
            linkedin: docSnap.data().linkedin,
            twitter: docSnap.data().twitter,



          };
          console.log(docSnap.data().items);
          setItemsOrder(docSnap.data().items);
          setInitialValues(tempObj);
          setFetchloading(false);
        } else {
          console.log("No such document!");
        }
      } catch (err) {
      } finally {
      }
    };

    fetchDocument();
  }, []);

  return (
    <>
      <HelmetInfo titlePage={t("addNewProject")} />{" "}
      {/* Translated page title */}
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <WorkHeaderInfo
          title={"Edit Our Clinc section"} // Translated section title

        />
        {/* ========== START FORM PROJECT MANAGEMENT ========== */}
        <div className="form-project-management">
          {!Fetchloading && (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, handleChange }) => (
                <Form>
                  <div className="row g-3">
                    <div className="col-12 col-md-12">
                      <InputFiled
                        label={"email "}
                        name="email"
                        type="email"
                        placeholder=""
                        success
                        value={values.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-12">
                      <InputFiled
                        label={t("phone number")}
                        name="number"
                        type="number"
                        placeholder=""
                        success
                        value={values.number}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-12">
                      <InputFiled
                        label={"facebook"}
                        name="facebook"
                        type="text"
                        placeholder=""
                        success
                        value={values.facebook}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 col-md-12">
                      <InputFiled
                        label={t("instagram")}
                        name="instagram"
                        type="text"
                        placeholder=""
                        success
                        value={values.instagram}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12 col-md-12">
                      <InputFiled
                        label={"twitter"}
                        name="twitter"
                        type="text"
                        placeholder=""
                        success
                        value={values.twitter}
                        onChange={handleChange}
                      />
                    </div>   <div className="col-12 col-md-12">
                      <InputFiled
                        label={t("linkedin")}
                        name="linkedin"
                        type="text"
                        placeholder=""
                        success
                        value={values.linkedin}
                        onChange={handleChange}
                      />
                    </div>


                    {/* ========= END COL ======== */}

                    <button className="btn-main w-100" type={"submit"}>
                      {loading ? (
                        <span className="loader"></span>
                      ) : (
                        <>

                          edit Section
                        </>
                      )}

                      {/* Translated button text */}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>)}
        </div>
        {/* ========== END FORM PROJECT MANAGEMENT ========== */}
      </div>

    </>
  );
};

export default Contact;
